const alternativeImageURL = 'https://www.wolflair.com/wp-content/uploads/2017/01/placeholder.jpg';
export default alternativeImageURL;